export default __webpack_public_path__ + "static/media/VIDEO_IVP_POUR_SITE.db006249.mp4";